type JsonValue =
  | string
  | number
  | boolean
  | null
  | JsonObject
  | JsonArray
  | JsonRecord

interface JsonRecord extends Record<string, JsonValue> {}
interface JsonObject {
  [key: string]: JsonValue
}
interface JsonArray extends Array<JsonValue> {}

export function createStableObject<T extends any>(obj: T): T {
  if (Array.isArray(obj)) {
    return obj.map(createStableObject) as T
  } else if (typeof obj === "object" && obj !== null) {
    const sortedObj: JsonObject = {}
    Object.keys(obj as JsonObject)
      .sort()
      .forEach((key) => {
        // @ts-ignore
        sortedObj[key] = createStableObject(obj[key])
      })

    return sortedObj as T
  }
  return obj
}
